export const MODAL_CLOSE_BTN_ID = "modal-close-btn";
